import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || null,
  user: JSON.parse(localStorage.getItem("user") || "null")
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state,action) => {
      state.token = action.payload;
      localStorage.setItem("token",action.payload);
    },
    setUser: (state,action) => {
      state.token = action.payload;
      localStorage.setItem("token",action.payload);
    },
    clearAuth: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const { setToken,clearAuth } = authSlice.actions;
export default authSlice.reducer;
